module.exports = __webpack_public_path__ + "img/timeline_mainevent-2.6cea24eb.jpg";